import { GeometryObject } from 'geojson';
import { Layer } from './layer/layer.model';

/**
 * This class describes rendered map object like polygon, point, marker, etc.
 */
export class MapElement<T extends GeometryObject, TProperties = any> {
  public id: string | number;
  public layer: Layer;
  public properties: TProperties;
  public type: string;
  public geometry: T;

  constructor(id, layer, properties, type, geometry) {
    this.id = id;
    this.layer = layer;
    this.properties = properties;
    this.type = type;
    this.geometry = geometry;
  }
}
